module.exports = __webpack_public_path__ + "img/qr_code_ko.7307d56d.png";